import { ChangeEvent, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { CustomAccordion, CustomSwitch } from '../../../../shared/uiComponents';
import { MaintenanceHeader } from '../SkillAcquisition/SkillAreas/Components/SkillAccordionHeader';
import { MaintenanceContent } from '../SkillAcquisition/SkillAreas/Components/SkillAccordionContent';
import { useScreenWidth } from '../../../../shared/Helpers/hooks';

import { DispatchProperties, useSelector } from '../../../../redux/store';
import { getSkillAreas } from '../../../../redux/State/clientSlice/skillAreaSlice';

const MasteredTargets = () => {
	const dispatch = useDispatch<DispatchProperties>();
	const { clientId } = useParams();

	const screenWidth = useScreenWidth();
	const isMobile = screenWidth <= 768;

	const skillAreas = useSelector((state) => state.skillArea.skillAreas);
	const [includeArchived, setIncludeArchived] = useState<boolean>(false);

	useEffect(() => {
		if (!clientId) return;
		dispatch(getSkillAreas({ clientId, includeArchived }));
	}, [clientId, includeArchived, dispatch]);

	const showArchivedSkillAreasHandler = (event: ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;
		setIncludeArchived(checked);
	};

	return (
		<>
			<div className="maintenanceHeader">
				<CustomSwitch
					label="Show Archived"
					checked={includeArchived}
					onChange={showArchivedSkillAreasHandler}
					backgroundType="base"
					fullWidth={isMobile}
				/>
			</div>
			<div className="maintenanceContainer">
				{skillAreas?.map((item) => (
					<div className="maintenanceAccordion" key={item.id}>
						<CustomAccordion
							HeaderContent={() => <MaintenanceHeader item={item} />}
							Content={() => <MaintenanceContent item={item} />}
							defaultExpanded={false}
							accordionClassName="clientInfoAccordion"
							accordionDetailsClassName="maintenanceAccordionDetails"
						/>
					</div>
				))}
			</div>
		</>
	);
};

export default MasteredTargets;
